import { Component, OnInit, ElementRef , ViewChild} from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { UploadService } from './../d-i/upload.service';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-chapter-announcements',
  templateUrl: './chapter-announcements.component.html',
  styleUrls: ['./chapter-announcements.component.css']
})
export class ChapterAnnouncementsComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  @ViewChild(NgSelectComponent, { static: false })
  ngSelect: NgSelectComponent;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string;
  chapterId: number;
  createdBy: any = this.loginData.userId;
  createdDateTime: any;
  modifiedBy: any = this.loginData.userId;
  modifiedDateTime: any;
  userId: any = this.loginData.userId;
  adminId: any = localStorage.getItem('adminId');
  numberOfElements: number;
  currentPage = 0;
  currentNumberOfElements = 10;
  totalPages = 0;
  roleList: any;
  tableShow: any;
  limit = 10;
  currentShowingElements = 10;
  searchKey: any;
  searchTerm: any;
  siteData: any;
  siteList: any;
  siteListSearch: any;
  selectedBpgsData: any;
  bpgList: any;
  bpgListSearch: any;
  selectedSiteId: any = Number(localStorage.getItem('userSiteId'));
  selectedBpgSearch: any;
  selectedErgId: any;
  selectedSite: any;
  selectedSiteSearch: any;

  siteAndPath: any;
  selectedBpg: any;
  allBpgIds: any;
  allSiteIds: any;
  landingData: any;
  loginUserAdminId: any = localStorage.getItem('adminId');
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginDataDetails: any = JSON.parse(localStorage.getItem('loginData'));
  eventPicture = true;
  uploadFileName: string = null;
  uploadFileExtension = false;
  width: number;
  height: number;
  lbl: any;
  uploadedFile: string = null;
  action = "";
  fileExtensionError = false;
  fileSizeExtensionError = false;
  selectedFile: File = null;
  uploadSizeConstant = "Upload < 500MB";
  selectedFileName: string = this.uploadSizeConstant;
  announcementFile = "";
  fileExtension: any;
  fileSize: number;
  fileList: File[] = [];
  eventList: any;
  selectedSiteIdSearch: any = 0;
  selectedErgIdSearch: any = 0;
  page = 0;
  isFileUploded = false;
  announcementItemsList: any = null;

  chapterList: any;
  chapterIds: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  awsUrls: any;
  announcementList: any;
  uploadFlag: any ="chapterAnnouncements";
  errorMsgUploadSave = false;
  leadAdminId: any = localStorage.getItem('leadAdminId');
  userAndRoleIdDTO: any;
  announcementTitle: any;
  announcementDescription : any;
  externalLinks : any;
  announceLinkValid = false;
  selectAllConstant = 'Select All';
  typeList: any[] = [{ type: this.selectAllConstant }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
  editandSavebtn: any;
  savebtn: any;
  chaptersAnnouncementId: any;
  alertUpdateSuccess: any;
  firstEdit = false;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  

  constructor(private readonly userService: SelfService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly  bpgEventsService: BpgEventsService,
    private readonly router: Router,
    private readonly environment: EnvironmentConfiguration,
    private readonly uploadService: UploadService) { }

  ngOnInit() {
    this.editandSavebtn = false;
    this.savebtn = true;
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    this.spinner.show();
    this.logUserAction();
    sessionStorage.removeItem("MembershipData");
    if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
      localStorage.setItem('adminId', '2');

    }
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
}
  if(localStorage.getItem('isbpgLeadAdmin')=== 'true'){
    this.isbpgLeadAdmin = true;
  }

    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')

    }

    this.bpgCommonService.getSessionToken();

    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {

      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
        this.chapterList = data;

        if (this.chapterList.length > 1) {
          this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
        }
        for (let i = 0; i < this.chapterList.length; i++) {
          if (i === 0) {
            this.chapterIds = this.chapterList[i].chapterId;
          }
          else {
            this.chapterIds = `${this.chapterIds},${this.chapterList[i].chapterId}`;
          }
        }

        this.siteData = {
          "filter": {
            chapterId: this.chapterIds
          },
          "moduleId": 0,
          "page": 0,
          "presentRole": "",
          "searchTerm": "",
          "size": 0,
          "sortDirection": "ASC",
          "sortProperty": "",
          "uid": ""
        }
        this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
          this.siteList = data;
          this.siteListSearch = data
          this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
          this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');
          this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });

          for (let i = 0; i < this.siteList.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteList[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
            }
          }
          for (let i = 0; i < this.siteListSearch.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteListSearch[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
            }
          }
          this.getBpgList();
          this.getBpgListSearch();
        });
      });

      this.getSiteName()
    }
    else if (this.loginUserAdminId === "1") {
      this.getSiteName()

      this.getSiteList();
      this.getBpgList();
      this.getBpgListSearch();
      this.getChapterAnnouncementList();

    }

    this.loginUserId = this.loginData.userId;

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }
  /** get site name in the dropdown for lead admin
    * @class ChapterAnnouncementComponent
    * @method getSiteName
    */
  getSiteName() {
    this.selectedSite = this.loginData.site.siteName;

  }

  /** get site list in the dropdown
    * @class ChapterAnnouncementComponent
    * @method getSiteList
    */
  getSiteList() {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      this.siteListSearch = data;

      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

      this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });
      if (this.siteList != null || this.siteListSearch != null) {
        for (const s of this.siteList) {
          if (s.siteId === this.selectedSiteId) {
            this.selectedSite = s.siteName;
          }
        }

        for (const s1 of this.siteListSearch) {
          if (s1.siteId === this.selectedSiteId) {
            this.selectedSite = s1.siteName;
          }
        }

        for (let i = 0; i < this.siteList.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteList[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
          }
        }

        for (let i = 0; i < this.siteListSearch.length; i++) {
          if (i === 0) {
            this.allSiteIds = this.siteListSearch[i].siteId;
          } else {
            this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
          }
        }
      }
    });
  }


  /** get chapter announcement list
   * @class ChapterAnnouncementComponent
   * @method getChapterAnnouncementList
   */
  getChapterAnnouncementList() {
    this.spinner.show();
    if (this.selectedSiteIdSearch === 0) {
      this.selectedSiteIdSearch = this.allSiteIds;
    }
    if (this.selectedErgIdSearch === 0) {
      this.selectedErgIdSearch = this.allBpgIds;
    }

    this.landingData = {
      "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch },
      "moduleId": 0,
      "page": this.page,
      "presentRole": "string",
      "searchTerm": "string",
      "size": this.limit,
      "sortDirection": "DESC",
      "sortProperty": "createdDateTime",
      "uid": "string"

    }

    this.userService.getChapterAnnouncementList(this.landingData).subscribe(data => {
      this.spinner.hide();
      if(data != null && data!== undefined)
      {
      this.announcementItemsList = data.content;
      this.numberOfElements = data.totalElements;
      
      if (this.announcementItemsList.length === 0) {
        this.noDataFound = true;
        this.tableShow = false;

      } else {
        this.noDataFound = false;
        this.tableShow = true;
      }
      }
      else
      {
        this.noDataFound = true;
        this.tableShow = false;
      }
    });
  }


  /** get bpg list in the dropdown
    * @class ChapterAnnouncementComponent
    * @method getBpgList
    */
  getBpgList() {
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteId,
        "adminId": this.loginUserAdminId,
        "userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if (this.bpgList.length === 0) {
        this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });

      } 
      if (this.bpgList != null) {

        for (const bpg of this.bpgList) {
          if (bpg.bpgId === this.selectedErgId) {
            this.selectedBpg = bpg.bpgName;
          }
        }

        for (let i = 0; i < this.bpgList.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgList[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
          }
        }
      }

    });
  }


  getBpgListSearch() {
    this.selectedBpgsData =
    {
      "filter": {
        "siteId": this.selectedSiteIdSearch,
        "adminId": this.loginUserAdminId,
        "userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgListSearch = data;

      if (this.bpgListSearch != null) {
        this.bpgListSearch.unshift({ bpgId: 0, bpgName: this.selectAllConstant });

        for (const bpg of this.bpgListSearch) {
          if (bpg.bpgId === this.selectedErgId) {
            this.selectedBpg = bpg.bpgName;
          }
        }


        for (let i = 0; i < this.bpgListSearch.length; i++) {
          if (i === 0) {
            this.allBpgIds = this.bpgListSearch[i].bpgId;
          } else {
            this.allBpgIds = `${this.allBpgIds}${this.bpgListSearch[i].bpgId},`;
          }
        }
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" ||  this.isbpgAdmin || this.isbpgLeadAdmin) {

          this.getChapterAnnouncementList();
        }
      }
    });
  }

  /** get chapter id
  * @class ChapterAnnouncementComponent
  * @method getChapterIds
  */
  getChapterIds() {
    this.landingData = {
      "filter": {
        "bpgId": this.selectedErgId,
        "siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if (data != null) {
        for (const d of data) {
          this.chapterId = d;
        }
      }
    });
  }


  /** For site change from site list
     * @class ChapterAnnouncementComponent
     * @method siteChange
     * @returns Promise
     */
  siteChange(event) {
    this.selectedErgId = null;
    this.selectedBpg = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.getBpgList();

  }
  /** For bpg change from bpg list
    * @class ChapterAnnouncementComponent
    * @method bpgChange
    * @returns Promise
    */

  bpgChange(event) {
    this.selectedErgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedErgId = event.bpgId;
    this.getChapterIds();



  }

  public onFileSelected(event) {
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    if (event.target.files.length > 0) {
      this.announcementFile = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
      this.fileExtension = this.announcementFile.split('.').pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {

        if (this.fileSize > 524288000) {
          this.fileSizeExtensionError = true;
        } else {
          this.fileExtensionError = false;
          this.fileSizeExtensionError = false;
          this.selectedFile = event.target.files[0] as File;
          this.selectedFileName = this.selectedFile.name;
          this.isFileUploded = true;
        }
      } else {
        this.fileExtensionError = true;
        this.selectedFileName = this.uploadSizeConstant;
      }
    }
  }

  /** checks if word exists in array
   * @class ChapterAnnouncementComponent
   * @method isInArray
   */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }



  /** For adding 365 days to current day
* @class ChapterAnnouncementComponent
* @method addDays
* @params Date, number
*/
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }


  /** to submit resource
   * @class ChapterAnnouncementComponent
   * @method onChapterAnnouncementSubmit
   */
  public onChapterAnnouncementSubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.alertUpdateSuccess = false;

    this.method = "addAnnouncement";
    this.param = '';
    if (this.editandSavebtn) {
      this.msg1 = " Are you sure you want to update ? ";
    } else {
      this.msg1 = " Are you sure you want to save ? ";
    }

  }


  /** to add new admin
    * @class ChapterAnnouncementComponent
    * @method addAnnouncement
    */
  addAnnouncement() {

    //removing special characters from filename
    const str = this.selectedFileName;
    const arr = str.split(".");
    const lastVal = arr.pop();
    const firstVal = arr.join(".");
    this.selectedFileName = `${firstVal.replace(/[&/\\#,+()$~%.'"_:*?<>{}]/g, '')}.${lastVal}`;

    this.timeOutError = false;
    let announcementData = null;
    this.modifiedDateTime = new Date();

 if(this.selectedFile === null || this.selectedFile === undefined)
 {
  this.selectedFileName = '';
 }
    if (this.editandSavebtn !== true) {
      announcementData = {
        "createdBy": this.createdBy,
        "createdDateTime": this.createdDateTime,
        "isActive": true,
        "modifiedBy": this.modifiedBy,
        "modifiedDateTime": this.modifiedDateTime,
        "announcementFile": this.selectedFileName,
        "bpgId": this.selectedErgId,
        "siteId": this.selectedSiteId,
        "announcementTitle": this.announcementTitle,
        "announcementDescription": this.announcementDescription,
        "externalLinks" : this.externalLinks,
        "chaptersAnnouncementId" : 0

      }
    } else {
      announcementData = {
        "chaptersAnnouncementId": this.chaptersAnnouncementId,
        "createdBy": this.createdBy,
        "createdDateTime": this.createdDateTime,
        "isActive": true,
        "modifiedBy": this.modifiedBy,
        "modifiedDateTime": this.modifiedDateTime,
        "announcementFile": this.selectedFileName,
        "bpgId": this.selectedErgId,
        "siteId": this.selectedSiteId,
        "announcementTitle": this.announcementTitle,
        "announcementDescription": this.announcementDescription,
        "externalLinks" : this.externalLinks
      }
    }
    const uploadData =
    {
      'category': 'uploadDocument',
    }
   


    this.spinner.show();

    this.userService.addchapterAnnouncement(announcementData).subscribe(data => {
      this.announcementList = data.body;
      this.spinner.hide();
      if (this.editandSavebtn === true) {
        this.spinner.hide();
        this.alertUpdateSuccess = true;
        this.deleteSuccess = false;
        this.errorMsgUploadSave = false;
        this.alertSuccess = false;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 300);
        this.getChapterAnnouncementList();

      }
      
      if (data.message !== undefined) {
        
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 300);
      }
      else if (data !== undefined) {
        if (this.selectedFile === null) {
         
          if (this.editandSavebtn !== true) {
            this.alertSuccess = true;
            
          }
          else{
            this.alertUpdateSuccess = true;
          }
          this.getChapterAnnouncementList();
        }
        if (this.selectedFile != null) {
          this.spinner.show();
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
            await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.announcementList.chaptersAnnouncementId, this.uploadFlag);
            if (localStorage.getItem('uploadError') === 'Error') {
              this.userService.deleteChapterAnnouncement(this.announcementList.chaptersAnnouncementId).subscribe(_data => {
                this.spinner.hide();

                this.errorMsgUploadSave = true;
                this.alertSuccess = false;
                this.deleteSuccess = false;
                localStorage.removeItem('uploadError')
              });
            } else {
              if (this.editandSavebtn !== true) {
                this.alertSuccess = true;
              }
              this.deleteSuccess = false;
              this.errorMsgUploadSave = false;

              this.getChapterAnnouncementList();

            }

            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinner.hide();
          }, err => {
            this.spinner.hide();

            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
          });
        }
      }

    });

  }


  /** For filtering data by current page
   * @class chapterComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getChapterAnnouncementList();
  }

  /** Confirm on reset
    * @class ChapterAnnouncementComponent
    * @method resetAnnouncement
    */
   resetAnnouncement() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.myInputVariable.nativeElement.value = "";
    this.selectedBpg = null;
    this.selectedErgId = null;
    this.selectedErgIdSearch = null;
    this.selectedSiteIdSearch = null;
    this.searchKey = null;
    this.LandingPaginationDTO.searchTerm = null;
    this.selectedFileName = this.uploadSizeConstant;
    this.selectedSiteId = Number(localStorage.getItem('userSiteId'));
    this.deleteSuccess = false;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.alertSuccess = false;
    this.selectedFile = null;
    this.isFileUploded = false;
    this.selectedBpgSearch = null;
    this.selectedSiteSearch = null;
    this.errorMsgUploadSave = false;
    this.announcementTitle = "";
    this.announcementDescription = "";
    this.externalLinks = "";
    this.announceLinkValid = false;
    this.selectedSite = this.loginData.site.siteName;
    this.eventPicture = true;
    this.editandSavebtn = false;
    this.savebtn = true;
    this.firstEdit = false;
    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" ||  this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.selectedSiteIdSearch = 0;
      this.selectedErgIdSearch = 0;
      this.getBpgListSearch();
    }
    this.getChapterAnnouncementList();
    this.getBpgList();
  }


  /** For site change from site list
   * @class ChapterAnnouncementComponent
   * @method siteChangeSearch
   * @returns Promise
   */
  siteChangeSearch(event) {

    this.selectedSiteIdSearch = event.siteId;
    this.getBpgListSearch();


  }
  /** For bpg change from bpg list
    * @class ChapterAnnouncementComponent
    * @method bpgChangeSearch
    * @returns Promise
    */

  bpgChangeSearch(event) {
    this.selectedErgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedErgIdSearch = event.bpgId;
    this.selectedErgId = event.bpgId;
    this.getChapterIds();


  }

  /** confirmation to delete gallery
  * @class ChapterAnnouncementComponent
  * @method deleteAnnouncementConfirmation
  */
  public deleteAnnouncementConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.alertUpdateSuccess = false;
    this.method = "deleteAnnouncement";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete ? ";
  }

  /** to delete announcement
* @class ChapterAnnouncementComponent
* @method deleteAnnouncement
*/
  deleteAnnouncement(id) {
    this.spinner.show();
    this.userService.deleteChapterAnnouncement(id).subscribe(_data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;

      if (this.announcementItemsList.length === 1 && this.numberOfElements > 10) {
        this.currentPage = 0;
        this.page = 0;
        this.currentShowingElements = 10

      }

      this.getChapterAnnouncementList();
    });
  }


  /** to reset resource
   * @class ChapterAnnouncementComponent
   * @method resetClick
   */
  resetClick() {
    this.method = "resetAnnouncement";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  getChapterAnnouncementListSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getChapterAnnouncementList();

  }
  /** link validation
* @class DIComponent
* @method onLinkType
*/
onLinkType(event, type) {
  const re = /^(https?:\/\/)?(www.\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]?/;
    if (re.test(String(event.target.value).toLowerCase()) === false) {
      if (type === 'news') {
        if (event.target.value !== "") {
          this.announceLinkValid = true;
        }
        else
        {
          this.announceLinkValid = false;
        }
      }

    }else if(type === 'news'){
      this.announceLinkValid = false;
    }
}


  /** to add new admin
   * @class ChapterAnnouncementComponent
   * @method updateAnnouncement
   */
   updateAnnouncement(data) {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.alertSuccess = false;
    this.alertFailure = false;
    this.editandSavebtn = true;
    this.savebtn = false;
    this.timeOutError = false;
    this.modifiedDateTime = new Date();
    this.modifiedBy = this.loginDataDetails['userId'];
    this.createdBy = this.loginDataDetails['userId'];
    this.createdDateTime = new Date();
    this.selectedFileName = data.announcementFile;
    this.announcementTitle = data.announcementTitle;
    this.selectedBpg = data.bpgName;
    this.selectedErgId = data.bpgId;
    this.selectedSite = data.siteName;
    this.selectedSiteId = data.siteId;
    this.chaptersAnnouncementId = data.chaptersAnnouncementId;
    this.announcementDescription =  data.announcementDescription;
    this.externalLinks =  data.externalLinks;
    this.announceLinkValid = false;
    this.fileSizeExtensionError = false;
    this.fileExtensionError = false;
    if(this.selectedFileName === null || this.selectedFileName ===  undefined || this.selectedFileName === ''){
    this.selectedFileName = this.uploadSizeConstant;
    }
  }

  public editDocument(data, i) {
    if (this.firstEdit === false) {
      this.firstEdit = true;
      this.updateAnnouncement(data);
    } else {
      document.getElementById('edit' + i).setAttribute('data-toggle', 'modal');
      document.getElementById('edit' + i).setAttribute('data-target', '#myModal');
      this.method = "updateAnnouncement";
      this.param = data;
      this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "Chapter Announcement Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}
